import { useRef } from 'react';
import { StoryCarouselFrame, StoryCarouselStage } from '../../StoryViewer.styles';

const StoryViewerCarousel = ({
	isSliding,
	direction,
	animating,
	onTransitionEnd,
	leavingFrame,
	centerFrame,
	enteringFrame,
}) => {
	const completedRef = useRef(false);

	const handleTransitionEnd = (event) => {
		if (event.propertyName !== 'transform') {
			return;
		}

		if (!animating || completedRef.current) {
			return;
		}

		completedRef.current = true;
		onTransitionEnd();
	};

	if (!isSliding) {
		completedRef.current = false;
		return centerFrame;
	}

	completedRef.current = false;

	return (
		<StoryCarouselStage>
			<StoryCarouselFrame
				$role="leaving"
				$direction={direction}
				$animating={animating}
				onTransitionEnd={handleTransitionEnd}
			>
				{leavingFrame}
			</StoryCarouselFrame>
			<StoryCarouselFrame
				$role="entering"
				$direction={direction}
				$animating={animating}
				onTransitionEnd={handleTransitionEnd}
			>
				{enteringFrame}
			</StoryCarouselFrame>
		</StoryCarouselStage>
	);
};

export default StoryViewerCarousel;
